import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as ToolScenarioIntegrationPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute, RouteStaticData } from "utils/createTenantFileRoute.ts";

const staticData: RouteStaticData = {
    permissions: [PermissionEnum.ToolIntegration, PermissionEnum.ToolScenarioField],
    showInSideMenu: true,
    sideMenuParent: "lazy",
    label: "pages.tool.scenario.title",
    sort: 2,
    redirects: [ToolScenarioIntegrationPage],
    defaultRedirect: ToolScenarioIntegrationPage,
};

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/")({
    component: ScenarioIndexPage,
    staticData,
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.tool.scenario.title"),
    }),
});

function ScenarioIndexPage() {
    return <RedirectPage />;
}

// Delay sideMenuParent after parent route is initialized
import("routes/_authenticated/$tenantSlug/_layout/tool/index.tsx").then((mod) => {
    staticData.sideMenuParent = mod.Route;
});
